module.exports = __webpack_public_path__ + "img/secondary-2.1fb8c00b.jpg";